import { mount } from "svelte";
import App from "./App.svelte";
import "./app.css";
import { install as installErrorReporter } from "$lib/errors";

installErrorReporter();

const app = mount(App, { target: document.getElementById("app")! });

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  navigator.serviceWorker.register("/service-worker.js").then((reg) => {
    reg.update().catch(() => {});
  }).catch(() => {});
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    location.reload();
  });
}

export default app;
